import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { ModalDirective } from "ngx-bootstrap";

import { GUID, Param } from "app/brightserve/brightserve.module";
import { Location } from "app/common/location";

import { ClientsService } from 'app/clients/clients.service';
import { Client } from "app/shared/shared.module";
import { BusyLoaderService } from "app/shared/components/busy-loader.service";
import { NotificationsService } from "angular2-notifications";

@Component({
    selector: 'app-clients-list',
    templateUrl: './clients-list.component.html',
    styleUrls: ['./clients-list.component.css']
})
export class ClientsListComponent implements OnInit {

    Clients: Array<Client> = [];
    NewClient: Client = new Client();
    GettingClients: Subscription;
    AddClientSubscription: Subscription;

    ContactStatuses: Param[] = [
        new Param({ Entity: "Client", Field: "ContractStatus", Value: "Active" }),
        new Param({ Entity: "Client", Field: "ContractStatus", Value: "Expired" }),
    ];

    @ViewChild('NewOrganisationModal') public modal: ModalDirective
    constructor(private clientsService: ClientsService, private router: Router, private busyLoaderService: BusyLoaderService, private _notification: NotificationsService) { }

    ngOnInit() {
        var ob = this.clientsService.GetClients();
        this.busyLoaderService.AddLoadingObservable(ob);
        this.GettingClients = ob.subscribe(
            clients => {
                this.Clients = clients;
            }, err => {
                console.log(err);
            }
        );
    };

    ngOnDestroy() {
        if (this.GettingClients != null)
            this.GettingClients.unsubscribe();
    }

    OpenModal() {
        this.NewClient = Client.NewClient();
        this.modal.show();
    }

    SaveNewOrganisation() {
        this.AddClientSubscription = this.clientsService.CreateClient(this.NewClient).subscribe(
            data => {
                this.modal.hide();
                this.router.navigate(['/client/' + data.Id]);
                this._notification.success("Save Success", "Client created successfully")
            }, err => {
                console.log(err);
                this._notification.error("Save Error", "Client wasn't saved successfully")
            }
        )
    };
}



// WEBPACK FOOTER //
// ./src/app/clients/list/clients-list.component.ts